/* eslint-disable no-console */
import handleLogout from '@/components/MainHeader/utils/logout'
import isSSR from '@/utils/isSSR'
import { ErrorCallback } from './types'

/**
 * Handles authentication-related errors (UNAUTHENTICATED, UNAUTHORIZED)
 * @param callback - Callback function to execute after handling
 */
export const handleAuthenticationError = (callback: ErrorCallback): void => {
  console.log('↔ ~ HANDLE Error: Authentication failed')

  setTimeout(() => {
    if (!isSSR()) {
      handleLogout()
      window.location.href = '/'
    }
  }, 1500)

  callback('UNAUTHENTICATED')
}
